import type { StorefrontId } from '@mentora/data-access'

/**
 * Storefront identity for apps/formed-web — Formed.
 *
 * Currently the only storefront. When apps multiply, each app's
 * `lib/storefront.ts` declares ITS storefront id; the rest of the lib re-exports
 * the matching auth/queries/helpers via this constant.
 */
export const STOREFRONT: StorefrontId = 'formed'
